/**
 * Body scroll lock: disables document scroll and touch scrolling.
 * Optional exception selector or element allows scrolling within a specific area (e.g. menu drawer).
 */
let exceptionSelector;

const preventDefault = function (e) {
  if (exceptionSelector) {
    const target = e.target;
    if (typeof exceptionSelector === 'string' && target.closest(exceptionSelector)) {
      return;
    }
    if (exceptionSelector instanceof Element && exceptionSelector.contains(target)) {
      return;
    }
  }

  e.preventDefault();
  e.stopPropagation();

  return false;
};

function disableTouchScroll(tmpExceptionSelector) {
  exceptionSelector = tmpExceptionSelector;
  document.addEventListener('touchmove', preventDefault, { passive: false });
}

function enableTouchScroll() {
  const opts = { passive: false };
  document.removeEventListener('touchmove', preventDefault, opts);
}

// Expose for use by homepage-header and other sections
window.disableTouchScroll = disableTouchScroll;
window.enableTouchScroll = enableTouchScroll;
